import { Builder } from "@builder.io/react";
import { allowedFileTypesVideo, commonInputs, registerMenuGroups } from "./helper";
import { Feature1, Feature10, Feature11, Feature12, Feature13, Feature14, Feature15, Feature16, Feature17, Feature18, Feature19, Feature2, Feature20, Feature21, Feature22, Feature23, Feature24, Feature25, Feature26, Feature27, Feature28, Feature3, Feature4, Feature5, Feature6, Feature7, Feature8, Feature9 } from "../components/Feature";

const featuresGroups = [
  {
    name: "Feature Components",
    items: [
      { name: "Feature 1" },
      { name: "Feature 2" },
      { name: "Feature 3" },
      { name: "Feature 4" },
      { name: "Feature 5" },
      { name: "Feature 6" },
      { name: "Feature 7" },
      { name: "Feature 8" },
      { name: "Feature 9" },
      { name: "Feature 10" },
      { name: "Feature 11" },
      { name: "Feature 12" },
      { name: "Feature 13" },
      { name: "Feature 14" },
      { name: "Feature 15" },
      { name: "Feature 16" },
      { name: "Feature 17" },
      { name: "Feature 18" },
      { name: "Feature 19" },
      { name: "Feature 20" },
      { name: "Feature 21" },
      { name: "Feature 22" },
      { name: "Feature 23" },
      { name: "Feature 24" },
      { name: "Feature 25" },
      { name: "Feature 26" },
      { name: "Feature 27" },
      { name: "Feature 28" },
    ]
  }
];

export const registerFeatureComponents = () => {
  registerMenuGroups(featuresGroups);

  // Feature Components
  Builder.registerComponent(Feature1, {
    name: "Feature 1",
    friendlyName: "Feature 1",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
      }),
      {
        name: "featureWithThumbnail",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "features",
        type: "list",
        defaultValue: [
          {
            title: "Feature 1",
            subtitle: "Subtitle 1",
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            link: "/",
          },
          {
            title: "Feature 2",
            subtitle: "Subtitle 2",
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            link: "/",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeSubtitle: true,
          }),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
            showIf: `options.get('featureWithThumbnail') === true`,
          }),
          {
            name: "link",
            type: "url",
          },
        ],
      },
    ],
  });

  Builder.registerComponent(Feature2, {
    name: "Feature 2",
    friendlyName: "Feature 2",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "removePaddingTop",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "removePaddingBottom",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "mediaPosition",
        type: "string",
        enum: ["left", "right"],
        defaultValue: "right",
      },
      {
        name: "mediaPositionMobile",
        type: "string",
        enum: ["top", "bottom"],
        defaultValue: "bottom",
      },
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
      {
        name: "featuredItem",
        type: "string",
        enum: ["video", "image"],
        defaultValue: "video",
      },
      {
        name: "withBorder",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "video",
        type: "url",
        showIf: `options.get('featuredItem') === 'video'`,
        defaultValue: "/",
      },
      {
        name: "loopVideo",
        type: "file",
        allowedFileTypes: allowedFileTypesVideo,
        showIf: `options.get('featuredItem') === 'video'`,
        helperText: "Loop video has higher priority than the image below. and will fallback to image below if error occurs.",
      },
      ...commonInputs.imageInput({
        name: "image",
        includeAltText: true,
        showIf: `options.get('featuredItem') === 'image' || options.get('featuredItem') === 'video'`,
      }),
    ],
  });

  Builder.registerComponent(Feature3, {
    name: "Feature 3",
    friendlyName: "Feature 3",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "leftContent",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          hasButton: true,
          buttonText: "Button",
          buttonLink: "/",
          buttonStyle: "outline",
          microCopy: "Microcopy",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false})
        ],
      },
      {
        name: "rightContent",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          hasButton: true,
          buttonText: "Button",
          buttonLink: "/",
          buttonStyle: "outline",
          microCopy: "Microcopy",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false})
        ],
      },
    ],
  });

  Builder.registerComponent(Feature4, {
    name: "Feature 4",
    friendlyName: "Feature 4",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "items",
        type: "list",
        defaultValue: [
          {
            icon: "check_circle",
            title: "Title 1",
            content: "Content 1",
          },
          {
            icon: "check_circle", 
            title: "Title 2",
            content: "Content 2",
          },
          {
            icon: "check_circle",
            title: "Title 3",
            content: "Content 3",
          },
          {
            icon: "check_circle",
            title: "Title 4",
            content: "Content 4",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeIcon: true,
            includeTitle: true,
            includeContent: true,
          }),
        ],
      },
      {
        name: "itemsWithDarkIconBg",
        type: "boolean",
        defaultValue: false,
      },
    ],
  });

  Builder.registerComponent(Feature5, {
    name: "Feature 5",
    friendlyName: "Feature 5",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
      {
        name: "features",
        type: "list",
        defaultValue: [
          {
            content: "Feature 1",
          },
          {
            content: "Feature 2",
          },
          {
            content: "Feature 3",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeContent: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Feature6, {
    name: "Feature 6",
    friendlyName: "Feature 6",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "items",
        type: "list",
        defaultValue: [
          {
            title: "Title 1",
            content: "Content 1",
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            hasButton: true,
            buttonText: "Button",
            buttonLink: "/",
            buttonStyle: "link",
          },
          {
            title: "Title 2",
            content: "Content 2",
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            hasButton: true,
            buttonText: "Button",
            buttonLink: "/",
            buttonStyle: "link",
          },
          {
            title: "Title 3",
            content: "Content 3",
            image: "/placeholder.svg",
            imageAltText: "Image 3",
            hasButton: true,
            buttonText: "Button",
            buttonLink: "/",
            buttonStyle: "link",
          },
          {
            title: "Title 4",
            content: "Content 4",
            image: "/placeholder.svg",
            imageAltText: "Image 4",
            hasButton: true,
            buttonText: "Button",
            buttonLink: "/",
            buttonStyle: "link",
          },
          {
            title: "Title 5",
            content: "Content 5",
            image: "/placeholder.svg",
            imageAltText: "Image 5",
            hasButton: true,
            buttonText: "Button",
            buttonLink: "/",
            buttonStyle: "link",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: true}),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Feature7, {
    name: "Feature 7",
    friendlyName: "Feature 7",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "removePaddingBottom",
        type: "boolean",
        defaultValue: false,
      },
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
      {
        name: "card",
        type: "object",
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
            includeLink: true,
          }),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Feature8, {
    name: "Feature 8",
    friendlyName: "Feature 8",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "stickyTitlePanel",
        type: "boolean",
        defaultValue: false,
      },
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      {
        name: "featureItems",
        type: "list",
        defaultValue: [
          {
            icon: "/",
            title: "Feature 1",
            content: "Content 1",
            link: "/",
          },
          {
            icon: "/",
            title: "Feature 2",
            content: "Content 2",
            link: "/",
          },
          {
            icon: "/",
            title: "Feature 3",
            content: "Content 3",
            link: "/",
          },
          {
            icon: "/",
            title: "Feature 4",
            content: "Content 4",
            link: "/",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeIcon: true,
            includeTitle: true,
            includeContent: true,
            includeLink: true,
          }),
        ],
      },
      
      
    ],
  })

  Builder.registerComponent(Feature9, {
    name: "Feature 9",
    friendlyName: "Feature 9",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      {
        name: "leftContent",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          hasButton: true,
          buttonText: "Button",
          buttonLink: "/",
          buttonStyle: "outline",
          microCopy: "Microcopy",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
        ],
      },
      {
        name: "rightContent",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          hasButton: true,
          buttonText: "Button",
          buttonLink: "/",
          buttonStyle: "outline",
          microCopy: "Microcopy",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false})
        ],
      },
    ],
  });

  Builder.registerComponent(Feature10, {
    name: "Feature 10",
    friendlyName: "Feature 10",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "items",
        type: "list",
        defaultValue: [
          {
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            imageCaption: "Caption 1",
            icon: "check_circle",
            title: "Title 1",
            content: "Content 1",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            imageCaption: "Caption 2",
            icon: "check_circle", 
            title: "Title 2",
            content: "Content 2",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 3",
            imageCaption: "Caption 3",
            icon: "check_circle",
            title: "Title 3",
            content: "Content 3",
          },
        ],
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
            includeCaption: true,
          }),
          ...commonInputs.contentInputs({
            includeIcon: true,
            includeTitle: true,
            includeContent: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Feature11, {
    name: "Feature 11",
    friendlyName: "Feature 11",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "leftContent",
        type: "object",
        defaultValue: {
          title: "Title",
          content: "Content",
          hasButton: true,
          buttonText: "Button",
          buttonLink: "/",
          buttonStyle: "outline",
          microCopy: "Microcopy",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false})
        ],
      },
      {
        name: "rightContent",
        type: "object",
        defaultValue: {
          title: "Title",
          content: "Content",
          hasButton: true,
          buttonText: "Button",
          buttonLink: "/",
          buttonStyle: "outline",
          microCopy: "Microcopy",
        },
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false})
        ],
      },  
    ],
  });

  Builder.registerComponent(Feature12, {
    name: "Feature 12",
    friendlyName: "Feature 12",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
      {
        name: "featureItemsWithImage",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "items",
        type: "list",
        defaultValue: [
          {
            text: "Text 1",
            image: "/placeholder.svg",
            imageAltText: "Image 1",
          },
          {
            text: "Text 2",
            image: "/placeholder.svg",
            imageAltText: "Image 2",
          },
          {
            text: "Text 3",
            image: "/placeholder.svg",
            imageAltText: "Image 3",
          },
          {
            text: "Text 4",
            image: "/placeholder.svg",
            imageAltText: "Image 4",
          },
          {
            text: "Text 5",
            image: "/placeholder.svg",
            imageAltText: "Image 5",
          },
          {
            text: "Text 6",
            image: "/placeholder.svg",
            imageAltText: "Image 6",
          },
          {
            text: "Text 7",
            image: "/placeholder.svg",
            imageAltText: "Image 7",
          },
          {
            text: "Text 8",
            image: "/placeholder.svg",
            imageAltText: "Image 8",
          },
        ],
        subFields: [
          {
            name: "text",
            type: "string",
          },
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Feature13, {
    name: "Feature 13",
    friendlyName: "Feature 13",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: true}),
      ...commonInputs.secondaryButtonInputs(),
      {
        name: "integrations",
        type: "list",
        defaultValue: [
          {
            image: "/placeholder.svg",
            imageAltText: "Image 1",
          },
          {
            icon: "automation",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 3",
          },
        ],
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          {
            name: "icon",
            type: "string",
            helperText: "Icon name google material symbols, ex: check_circle (image above has higher priority)",
          },
        ],
      },
      ...commonInputs.imageInput({
        name: "image",
        includeAltText: true,
      }),
    ],
  });

  Builder.registerComponent(Feature14, {
    name: "Feature 14",
    friendlyName: "Feature 14",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "leftContent",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          hasButton: true,
          buttonText: "Button",
          buttonLink: "/",
          buttonStyle: "outline",
          microCopy: "Microcopy", 
          image: "/placeholder.svg",
          imageAltText: "Image 1",
        },
        subFields: [
          {
            name: "backgroundColor",
            type: "color",
          },
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }), 
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
      {
        name: "rightContent",
        type: "object",
        defaultValue: {
          badge: "Badge",
          title: "Title",
          content: "Content",
          hasButton: true,
          buttonText: "Button",
          buttonLink: "/",
          buttonStyle: "outline",
          microCopy: "Microcopy",
          image: "/placeholder.svg",
          imageAltText: "Image 1",
        },
        subFields: [
          {
            name: "backgroundColor",
            type: "color",
          },
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: false}),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Feature15, {
    name: "Feature 15",
    friendlyName: "Feature 15",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "removePaddingBottom",
        type: "boolean",
        defaultValue: false,
      },
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
      {
        name: "items",
        type: "list",
        defaultValue: [
          {
            title: "Title 1",
            content: "Content 1",
            link: "/",
            image: "/placeholder.svg",
            imageAltText: "Image 1",
          },
          {
            title: "Title 2",
            content: "Content 2",
            link: "/",
            image: "/placeholder.svg",
            imageAltText: "Image 2",
          },
          {
            title: "Title 3",
            content: "Content 3",
            link: "/",
            image: "/placeholder.svg",
            imageAltText: "Image 3",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
            includeLink: true,
          }),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Feature16, {
    name: "Feature 16",
    friendlyName: "Feature 16",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "removePaddingBottom",
        type: "boolean",
        defaultValue: false,
      },
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
      {
        name: "items",
        type: "list",
        defaultValue: [
          {
            title: "Title 1",
            content: "Content 1",
            tabShortDescription: "Tab Short Description 1",
            link: "/",
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            buttonText: "Button Text 1",
            buttonLink: "/",
            buttonStyle: "outline",
          },
          {
            title: "Title 2",
            content: "Content 2",
            tabShortDescription: "Tab Short Description 2",
            link: "/",
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            buttonText: "Button Text 2",
            buttonLink: "/",
            buttonStyle: "outline",
          },
          {
            title: "Title 3",
            content: "Content 3",
            tabShortDescription: "Tab Short Description 3",
            link: "/",
            image: "/placeholder.svg",
            imageAltText: "Image 3",
            buttonText: "Button Text 3",
            buttonLink: "/",
            buttonStyle: "outline",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
          }),
          {
            name: "tabShortDescription",
            type: "longText",
          },
          ...commonInputs.buttonInputs({excludeMicroCopy: true}),
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
        ],
      },
    ],
  });

  Builder.registerComponent(Feature17, {
    name: "Feature 17",
    friendlyName: "Feature 17",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "removePaddingBottom",
        type: "boolean",
        defaultValue: false,
      },
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
      {
        name: "items",
        type: "list",
        defaultValue: [
          {
            title: "Title 1",
            content: "Content 1",
            link: "/",
          },
          {
            title: "Title 2",
            content: "Content 2",
            link: "/",
          },
          {
            title: "Title 3",
            content: "Content 3",
            link: "/",
          },
          {
            title: "Title 4",
            content: "Content 4",
            link: "/",
          },
          {
            title: "Title 5",
            content: "Content 5",
            link: "/",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
            includeLink: true,
          }),
          
        ],
      },
    ],
  });

  Builder.registerComponent(Feature18, {
    name: "Feature 18",
    friendlyName: "Feature 18",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "removePaddingBottom",
        type: "boolean",
        defaultValue: false,
      },
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
    ],
  });

  Builder.registerComponent(Feature19, {
    name: "Feature 19",
    friendlyName: "Feature 19",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: true}),
      ...commonInputs.secondaryButtonInputs(),
      ...commonInputs.imageInput({
        name: "leftImage",
        includeAltText: true, 
      }),
      ...commonInputs.imageInput({
        name: "rightTopImage",
        includeAltText: true, 
      }),
      ...commonInputs.imageInput({
        name: "rightBottomImage",
        includeAltText: true, 
      }),
      {
        name: "withTable",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "table",
        type: "object",
        showIf: `options.get('withTable') === true`,
        defaultValue: {
          tableTitle: "Table Title",
          tableHeader: [
            { col: "header1" },
            { col: "header2" },
            { col: "header3" },
          ],
          row: [
            {
              col: [
                { col: "col11" },
                { col: "col12" },
                { col: "col13" },
              ],
            },
            {
              col: [
                { col: "col21" },
                { col: "col22" },
                { col: "col23" },
              ],
            },
            { 
              col: [
                { col: "col31" },
                { col: "col32" },
                { col: "col33" },
              ],
            },
          ],
        },
        subFields: [
          {
            name: "tableTitle",
            type: "text",
          },
          {
            name: "tableHeader",
            type: "list",
            subFields: [
              {
                name: "col",
                type: "richText",
              },
            ],
          },
          {
            name: "tableHeaderIcon",
            type: "list",
            subFields: [
              {
                name: "icon",
                type: "text",
              },
            ],
          },
          {
            name: "row",
            type: "list",
            subFields: [
              {
                name: "col",
                type: "list",
                subFields: [
                  {
                    name: "col",
                    type: "richText",
                  },
                ],
              },
            ],
          },
        ]
      }
    ],
  });

  Builder.registerComponent(Feature20, {
    name: "Feature 20",
    friendlyName: "Feature 20",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "items",
        type: "list",
        defaultValue: [
          {
            title: "Title 1",
            content: "Content 1",
            link: "/",
            image: "/placeholder.svg",
            imageAltText: "Image 1",
          },
          {
            title: "Title 2",
            content: "Content 2",
            link: "/",
            image: "/placeholder.svg",
            imageAltText: "Image 2",
          },
        ],
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.contentInputs({
            includeTitle: true,
            includeContent: true,
            includeLink: true,
          }),
        ],
      }
    ],
  });

  Builder.registerComponent(Feature21, {
    name: "Feature 21",
    friendlyName: "Feature 21",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      {
        name: "items",
        type: "list",
        defaultValue: [
          {
            icon: "check_circle",
            title: "Title 1",
            content: "Content 1",
          },
          {
            icon: "check_circle", 
            title: "Title 2",
            content: "Content 2",
          },
          {
            icon: "check_circle",
            title: "Title 3",
            content: "Content 3",
          },
          {
            icon: "check_circle",
            title: "Title 4",
            content: "Content 4",
          },
        ],
        subFields: [
          ...commonInputs.contentInputs({
            includeIcon: true,
            includeTitle: true,
            includeContent: true,
          }),
        ],
      },
    ],
  }); 

  Builder.registerComponent(Feature22, {
    name: "Feature 22",
    friendlyName: "Feature 22",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "removePaddingBottom",
        type: "boolean",
        defaultValue: false,
      },
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
    ],
  });

  Builder.registerComponent(Feature23, {
    name: "Feature 23",
    friendlyName: "Feature 23",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
    ],
  });

  Builder.registerComponent(Feature24, {
    name: "Feature 24",
    friendlyName: "Feature 24",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
    ],
  });

  Builder.registerComponent(Feature25, {
    name: "Feature 25",
    friendlyName: "Feature 25",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "removePaddingTop",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "removePaddingBottom",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "mediaPosition",
        type: "string",
        enum: ["left", "right"],
        defaultValue: "right",
      },
      {
        name: "mediaPositionMobile",
        type: "string",
        enum: ["top", "bottom"],
        defaultValue: "bottom",
      },
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      ...commonInputs.secondaryButtonInputs(),
      {
        name: "featuredItem",
        type: "string",
        enum: ["video", "image"],
        defaultValue: "video",
      },
      {
        name: "withBorder",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "video",
        type: "url",
        showIf: `options.get('featuredItem') === 'video'`,
        defaultValue: "/",
      },
      {
        name: "loopVideo",
        type: "file",
        allowedFileTypes: allowedFileTypesVideo,
        showIf: `options.get('featuredItem') === 'video'`,
        helperText: "Loop video has higher priority than the image below. and will fallback to image below if error occurs.",
      },
      ...commonInputs.imageInput({
        name: "image",
        includeAltText: true,
        showIf: `options.get('featuredItem') === 'image' || options.get('featuredItem') === 'video'`,
      }),
    ],
  });

  Builder.registerComponent(Feature26, {
    name: "Feature 26",
    friendlyName: "Feature 26",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "items",
        type: "list",
        helperText: "Scroll-driven feature cards. On desktop, scrolling cycles through cards; on mobile they stack.",
        defaultValue: [
          {
            title: "Title 1",
            content: "Content 1",
            image: "/placeholder.svg",
            imageAltText: "Image 1",
          },
          {
            title: "Title 2",
            content: "Content 2",
            image: "/placeholder.svg",
            imageAltText: "Image 2",
          },
        ],
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: true}),
        ],
      }
    ],
  });

  Builder.registerComponent(Feature27, {
    name: "Feature 27",
    friendlyName: "Feature 27",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "removePaddingBottom",
        type: "boolean",
        defaultValue: false,
      },
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: true}),
      ...commonInputs.imageInput({
        name: "image",
        includeAltText: true,
      }),
    ],
  });
  Builder.registerComponent(Feature28, {
    name: "Feature 28",
    friendlyName: "Feature 28",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeBadge: true,
        includeTitle: true,
        includeContent: true,
      }),
      ...commonInputs.buttonInputs({excludeMicroCopy: false}),
      {
        name: "items",
        type: "list",
        defaultValue: [
          {
            image: "/placeholder.svg",
            imageAltText: "Image 1",
            badge: "Badge 1",
            title: "Title 1",
            content: "Content 1",
            hasButton: true,
            buttonText: "Button 1",
            buttonLink: "/",
            buttonStyle: "outline",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 2",
            badge: "Badge 2",
            title: "Title 2",
            content: "Content 2",
            hasButton: true,
            buttonText: "Button 2",
            buttonLink: "/",
            buttonStyle: "outline",
          },
          {
            image: "/placeholder.svg",
            imageAltText: "Image 3",
            badge: "Badge 3",
            title: "Title 3",
            content: "Content 3",
            hasButton: true,
            buttonText: "Button 3",
            buttonLink: "/",
            buttonStyle: "outline",
          },
        ],
        subFields: [
          ...commonInputs.imageInput({
            name: "image",
            includeAltText: true,
          }),
          ...commonInputs.contentInputs({
            includeBadge: true,
            includeTitle: true,
            includeContent: true,
          }),
          ...commonInputs.buttonInputs({excludeMicroCopy: true}),
        ],
      },
    ],
  });
};
